/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import {
  useGetTicketDetails,
  useAddNotes,
  useUpdateTicket,
  useSelfAssignTicket,
} from "services/tickets";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import {
  useLookupGetContracts,
  useLookupGetSecurityTypes,
  useLookupGetSites,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { emptyTicket, StatusContext } from "../constants";
import { disableTicketEditing, isCallCenterAgent } from "../utils";
import { useUser } from "hooks/use-user";
import ResolutionNotes from "components/tickets/resolution-notes";
import { TicketDetailsHeader } from "components/tickets/ticket-details-header";

const emptyRequest = {
  ...emptyTicket,
  activityType: "Voice of Staff",
  assignmentGroup: "Cash Admin",
};
export default function TGSIHelpDeskTicketDetails() {
  const [ticketDetails, setTicketDetails] = useState({ ...emptyRequest });
  const { status } = useContext(StatusContext);
  const params = useParams();
  const navigate = useNavigate();
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const {
    mutate: getSecurityTypes,
    data: securityTypesRes,
    isPending: gettingSecurityTypes,
  } = useLookupGetSecurityTypes();
  const {
    mutate: getContracts,
    data: contractsRes,
    isPending: gettingContracts,
  } = useLookupGetContracts();
  const {
    mutate: getSites,
    data: sitesRes,
    isPending: gettingSites,
  } = useLookupGetSites();

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
  } = useUpdateTicket();

  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();
  const {
    mutate: addTicketNotes,
    data: addNotesResponse,
    isPending: addingNotes,
    error: addNotesError,
    reset: resetNotesRequest,
  } = useAddNotes();

  const {
    mutate: selfAssign,
    data: selfAssignRes,
    isPending: selfAssigning,
  } = useSelfAssignTicket();

  const form = useForm({
    defaultValues: { ...emptyRequest },
  });

  useEffect(() => {
    getSecurityTypes();
    getContracts();
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);

  useEffect(() => {
    if (ticketDetailsRes && contractsRes) {
      if (ticketDetailsRes.status === 200) {
        const _details = {
          ...ticketDetailsRes.data,
        };
        form.reset({ ...emptyRequest, region: _details.state, ..._details });
        const valueObject = contractsRes?.data.find(
          (elm) => elm.name === _details.category
        );
        getSites(valueObject.id);
        setTicketDetails({ ..._details });
        resetDetailsApi();
      }
    }

    if (createTicketRes) {
      navigate(PATHS.allServiceAndNonServiceCalls);
    }

    if (addNotesResponse) {
      resetNotesRequest();
      form.resetField("notesRemarks");
      form.resetField("notesAdditionalRemarks");
      getTicket(params.ticketId);
    }
    if (addNotesError) {
      resetNotesRequest();
    }
    if (selfAssignRes) {
      navigate(PATHS.allServiceAndNonServiceCalls);
    }
  }, [
    createTicketRes,
    ticketDetailsRes,
    addNotesError,
    contractsRes,
    selfAssignRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    reportedBy: { required: "Please Enter Value" },
    requestorEmail: { required: "Please Enter Value" },
    requesterContactNo: { required: "Please Enter Value" },
    securityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    site: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
  };

  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      remarks: _data.updatedRemarks || "",
      additionalRemarks: _data.additionalRemarks || "",
      assignmentGroup: _data.assignmentGroup || "",
      tgsiSiteId: _data.tgsiSiteId,
      tgsiSiteName: _data.tgsiSiteName,
    };
    createTicket(payload);
  };

  const onContractChange = (data) => {
    const valueObject = contractsRes?.data.find((elm) => elm.name === data);
    getSites(valueObject.id);
    form.setValue("tgsiSiteId", "");
  };

  const onSiteChange = (data) => {
    const currentSite = sitesRes?.data.find((elm) => elm.id === data);
    if (currentSite) {
      form.setValue("tgsiSiteName", currentSite.siteName);
    }
  };
  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      ticketId: form.getValues("ticketId"),
    };
    addTicketNotes(payload);
  };

  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTicketEditing(status);
  }, [form.watch("status")]);
  const onSelfAssign = () => {
    selfAssign(ticketDetails.ticketId);
  };
  return (
    <>
      {creatingTicket ||
      gettingTicket ||
      gettingSecurityTypes ||
      gettingContracts ||
      addingNotes ||
      selfAssigning ||
      gettingSites ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <TicketDetailsHeader
          canSelfAssign
          isFormDisabled={isFormDisabled}
          isDirty={form.formState.isDirty}
          ticket={ticketDetails}
          onSave={form.handleSubmit(onSave)}
          onReset={onReset}
          onSelfAssign={onSelfAssign}
        />
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>TGSI Help Desk</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    disabled
                    name="caseNo"
                    label="TG Reference No"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="createdBy"
                    label="Opened By"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="priority"
                    label="Priority"
                  />{" "}
                  <FormInput
                    {...generalProps}
                    disabled
                    name="createDateTime"
                    label="Created"
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="reportedBy"
                    label="Requestor Name"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Security Type"
                    name="subCategory"
                    isRequired
                    placeholder="Select Security Type"
                    rules={verificationRules.subCategory}
                    data={securityTypesRes?.data || []}
                    text="name"
                    id="name"
                    disabled={isFormDisabled || isCSMAgent}
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="requesterContactNo"
                    label="Requestor Contact"
                  />{" "}
                  <FormDropdown
                    {...generalProps}
                    label="Contracts"
                    name="category"
                    isRequired
                    placeholder="Select Contract"
                    rules={verificationRules.category}
                    data={contractsRes?.data || []}
                    text="name"
                    id="name"
                    onChange={onContractChange}
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    disabled
                    name="requesterEmail"
                    label="Requestor Email"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sites"
                    name="tgsiSiteId"
                    isRequired
                    placeholder="Select Sites"
                    rules={verificationRules.sites}
                    data={sitesRes?.data || []}
                    text="displayText"
                    id="id"
                    disabled={isFormDisabled || isCSMAgent}
                    onChange={onSiteChange}
                    info={
                      form.watch("category")
                        ? ""
                        : "Select Contracts To Load Data"
                    }
                  />
                  {ticketDetails.status === "Closed" ||
                  ticketDetails.status === "Resolved" ? (
                    <>
                      <FormInput
                        {...generalProps}
                        disabled
                        name="serviceStartDateTime"
                        label="Service Start Date"
                      />
                      <FormInput
                        {...generalProps}
                        disabled
                        name="serviceEndDateTime"
                        label="Service End Date"
                      />
                    </>
                  ) : null}
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                disabled
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Remarks"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  (isFormDisabled &&
                                    ticketDetails.status !== "Cancelled")
                                }
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="additionalRemarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Additional Remarks"
                            // isRequired={true}
                            style={{
                              justifyContent: "start",
                              textAlign: "left",
                              width: "100%",
                              textWrap: "nowrap",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  isFormDisabled ||
                                  form.watch("In Progress") ||
                                  form.watch("Resolved") ||
                                  form.watch("Awaiting Customer Approval") ||
                                  form.watch("Awaiting Re-Opening")
                                }
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.additionalRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.additionalRemarks ? (
                              <p className="text-destructive text-xs">
                                {
                                  form.formState.errors.additionalRemarks
                                    .message
                                }
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <Tabs
                  defaultValue={
                    ticketDetails.status === "Cancelled" ||
                    ticketDetails.status === "Closed"
                      ? "notes"
                      : "resolutionNotes"
                  }
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="notes">Notes</TabsTrigger>
                    <TabsTrigger
                      value="resolutionNotes"
                      disabled={
                        ticketDetails.status === "Cancelled" ||
                        ticketDetails.status === "Closed"
                      }
                    >
                      Resolution Notes
                    </TabsTrigger>
                    <TabsTrigger value="information">
                      Additional Information
                    </TabsTrigger>
                    <TabsTrigger value="requestDetails">
                      Request Details
                    </TabsTrigger>
                    <TabsTrigger value="accessTiming">
                      Access Timings
                    </TabsTrigger>
                    <TabsTrigger value="denomination">Denomination</TabsTrigger>
                    <TabsTrigger value="resolutionInformation">
                      Resolution Information
                    </TabsTrigger>
                    <TabsTrigger value="System">system</TabsTrigger>
                  </TabsList>

                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        {isCCA ? (
                          <>
                            <FormField
                              control={form.control}
                              name="notesRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Work Notes" />

                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />
                            <FormField
                              control={form.control}
                              name="notesAdditionalRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Additional Comments" />
                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary mb-4"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />

                            <div className="flex flex-row w-full justify-end">
                              <Button variant="secondary" onClick={addNotes}>
                                Post
                              </Button>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className="px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={index}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>
                  <TabsContent value="resolutionNotes">
                    {ticketDetails?.activityType ? (
                      <ResolutionNotes
                        requestId={ticketDetails.ticketId}
                        ticket={ticketDetails}
                        ticketView
                      />
                    ) : (
                      <></>
                    )}
                  </TabsContent>
                  <TabsContent value="information">Coming Soon</TabsContent>
                  <TabsContent value="requestDetails">Coming Soon</TabsContent>
                  <TabsContent value="accessTiming">Coming Soon</TabsContent>
                  <TabsContent value="denomination">Coming Soon</TabsContent>
                  <TabsContent value="resolutionInformation">
                    Coming Soon
                  </TabsContent>
                  <TabsContent value="system">Coming Soon</TabsContent>
                </Tabs>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
